<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-添加
      -->
  <el-dialog title="添加分类" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">

      <el-form-item label="所属分类" :label-width="formLabelWidth">
        <el-select v-model="form.parent_id">
          <el-option label="顶级分类" value="0"></el-option>
          <el-option
            v-for="cat in addform.cateList"
            :value="cat.category_id"
            :label="cat.name"
            :key="cat.category_id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="分类名称" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="分类图片"
        prop="image_id"
        :label-width="formLabelWidth"
      >
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.image_id != ''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="显示方式" :label-width="formLabelWidth">
        <el-radio-group v-model="form.show_type">
          <el-radio :label="0">默认</el-radio>
          <el-radio :label="1">瀑布流</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="排序" :label-width="formLabelWidth">
        <el-input type="number" v-model="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addCategory" :loading="loading">确 定</el-button>
    </div>

     <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc" >上传图片</Upload>
  </el-dialog>
</template>

<script>
  import ArticleApi from '@/api/article.js';
  import Upload from "@/components/file/Upload";

  export default {
     components: {
        Upload,
      },

    data() {
      return {
        form: {
          /*名称*/
          name: '',
          sort: 1,
          parent_id: "0",
          image_id: "",
          show_type: 0,
        },
        formRules: {},
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
      };
    },
    props: ['open_add','addform'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*添加分类*/
      addCategory() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            ArticleApi.addCategiry(params, true).then(data => {
                self.loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
    },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/article/category/part/Add.vue